module.exports = __webpack_public_path__ + "img/ico-reporting.adb01583.svg";